import React from 'react';
import { ArrowRight, Sparkles, Smartphone, Code2, TrendingUp, Cpu } from 'lucide-react';

interface CtaBannerProps {
  onOpenConsultation: () => void;
}

export const CtaBanner: React.FC<CtaBannerProps> = ({ onOpenConsultation }) => {
  const pillars = [
    { label: 'AI Web Dev', icon: Code2, color: 'text-[#7B2EFF]' },
    { label: 'Mobile Apps', icon: Smartphone, color: 'text-[#159DE8]' },
    { label: 'Digital Marketing', icon: TrendingUp, color: 'text-[#FF851B]' },
    { label: 'Custom ERP', icon: Cpu, color: 'text-[#00C853]' },
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-r from-[#050A13] via-[#0B2342] to-[#071426] border-y border-[#1b2f4a] py-14">
      {/* Decorative colored glow strip */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-[#FF851B]/15 via-[#159DE8]/10 to-transparent pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-1/4 h-full bg-gradient-to-r from-[#159DE8]/10 to-transparent pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8 text-center lg:text-left">
        <div className="space-y-3 max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#071426] border border-[#1b2f4a] text-xs font-semibold text-[#FF851B]">
            <Sparkles size={13} />
            <span>COMMERCIAL SCALING & ARCHITECTURE</span>
          </div>
          
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white tracking-tight font-display">
            Have a Project in Mind?
          </h2>
          
          <p className="text-sm sm:text-base text-[#D5DFEC] leading-relaxed">
            Let's turn your ideas into powerful digital solutions. Connect technology, user experience, and digital marketing built around your business objectives.
          </p>

          {/* Service Pillar Tags */}
          <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 pt-1">
            {pillars.map((p, idx) => {
              const Icon = p.icon;
              return (
                <div 
                  key={idx}
                  className="flex items-center gap-1.5 px-3 py-1 rounded-lg bg-[#071426]/80 border border-[#1b2f4a] text-xs font-medium text-[#D5DFEC]"
                >
                  <Icon size={13} className={p.color} />
                  <span>{p.label}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center gap-3 shrink-0">
          <button
            onClick={onOpenConsultation}
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-gradient-to-r from-[#FF5A36] to-[#FF851B] text-white font-bold text-sm shadow-lg hover:shadow-glow-orange hover:scale-105 active:scale-95 transition-all duration-200"
          >
            <span>Let's Talk</span>
            <ArrowRight size={16} />
          </button>
        </div>
      </div>
    </section>
  );
};
